import { Link } from 'react-router-dom';
import { Button, Tooltip } from '@mui/material';
import { LinkButtonProps } from './types';
import { buildRedirectTranslatedUrl } from '../../lib/helperFuncs';
import ConditionalWrapper from '../ConditionalWrapper/ConditionalWrapper';

const LinkButton = ({ label, link, disabled, children, tooltipTitle,
  externalLink = false, ...rest }: 
  LinkButtonProps) => {
  const { renderOutsideReactRouter } = rest;
  
  if (renderOutsideReactRouter) {
    return <Button
      onClick={() => {
        externalLink ?  
          window.open(link as string, '_blank') :
          window.location.href = buildRedirectTranslatedUrl() as string + link as string;
      }}
      {...rest}
      disabled={disabled
        ? disabled
        : false}
    >
      {label || children}
    </Button>;
  }

  return (
    <ConditionalWrapper condition={!disabled}
      wrapper={(children) => <Link to={link} style={{ textDecoration: 'none' }}> 
        {children}
      </Link>
      }>
      <Tooltip
        title={tooltipTitle || ''}
        disableHoverListener={!disabled}
        PopperProps={{disablePortal: true}}
      >
        <span>
          <Button
            {...rest}
            disabled={!!disabled}
          >
            {label || children}
          </Button>
        </span>
      </Tooltip>
    </ConditionalWrapper>
  );
};

export default LinkButton;